import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from 'context/AuthContext';
import { useTranslation } from 'react-i18next';

const ToolsPage = () => {
  const { isAuthenticated } = useAuth();
  const { t } = useTranslation();
  
  const tools = [    {
      title: 'Safety Now',
      to: '/tools/safety-now',
      icon: '🔬',
      description: 'Beginner-friendly tool designed for individual with minimal knowledge on safety',
      features: {
        complete: [
          'Key hazards and alerts',
          'Safe handling, storage and transportation',
          'Chemical properties and hazards',
          'SDS upload and management (requires login)'
        ],
        inProgress: [
          'PPE recommendations',
          'Emergency response guidelines',
          'Automated SDS processing'
        ]
      },
      cta: 'Available Now'
    },
    {
      title: 'Safety Pro',
      to: '/tools/safety-pro',
      icon: '⚡',
      description: 'Advanced tool tailored for engineers and professionals for design of safety systems',
      features: {
        complete: [
          'Inertization calculation',
          'Ventilation calculation',
        ],
        inProgress: [
          'Chemical compatibility',
          'Gas dispersion analysis',
          'Bundwall sizing',
          'Leak rate estimation',
          'Relief sizing',
          'Mixture properties'
        ]
      },
      cta: 'Available Now (Beta Version)'
    },
    {
      title: 'Safety Guru',
      to: '/tools/safety-guru',
      icon: '👑',
      description: 'Tool designed for anyone seeking knowledge on advanced safety management concepts',
      features: {
        complete: [
          'Basic safety principles',
          'Emergency response',
        ],
        inProgress: [
          'Chemical handling guidelines',
          'Hazard identification',
          'Risk analysis',
          'In depth safety concepts and principles'
        ]
      },
      cta: 'Available Now (Beta Version)'    },
    {
      title: 'Safety Buddy',
      to: '/tools/safety-buddy',
      icon: '🚀',
      description: 'AI-powered assistant designed to assist users intelligent safety analysis and recommendations',
      features: {
        complete: [
          'Similar accident histories',
          'Hazard identification support',
        ],
        inProgress: [
          'Basic safety recommendations',
          'Chemical property insights',
          'PPE selection guidance',
          'Emergency response suggestions',
        ]
      },
      cta: 'Stay Tuned!'
    }
  ];

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-b from-white to-blue-50">

      {/* Hero Section */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-5xl mx-auto text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6 leading-tight">
            {t('tools.title')}
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            {t('tools.subtitle')}
          </p>
        </div>
      </div>

      {/* Features Section */}
      <div className="bg-gradient-to-b from-[#1a237e] to-[#0d47a1] w-full flex-grow shadow-2xl">
        
        {/* Safety Levels Section */}
        <div className="max-w-6xl mx-auto px-4 py-16">
          <h2 className="text-4xl font-bold text-white text-center mb-8">{t('tools.chooseSafetyLevel')}</h2>
          <p className="text-blue-200 text-center max-w-2xl mx-auto mb-16">{t('tools.chooseSafetyLevelDesc')}</p>          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tools.map((tool, index) => (
              <div key={tool.title}>
                <Link to={tool.to} className="no-underline group">
                  <div className="bg-white/95 p-8 rounded-2xl shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:bg-white h-full flex flex-col">
                    <div className="flex-grow space-y-6">
                      <div className="flex justify-center">
                        <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center group-hover:bg-blue-200 transition-colors">
                          <span className="text-3xl">{tool.icon}</span>
                        </div>
                      </div>
                      <div>
                        <h3 className="text-2xl font-bold text-gray-800 mb-3">{tool.title}</h3>
                        <p className="text-gray-600 mb-4">{tool.description}</p>
                        <ul className="space-y-3 text-gray-600">
                          {tool.features.complete.map((feature, idx) => (
                            <li key={idx} className="flex items-center">
                              <i className="fas fa-check text-green-500 mr-2"></i>
                              {feature}
                            </li>
                          ))}
                          {tool.features.inProgress.map((feature, idx) => (
                            <li key={idx} className="flex items-center">
                              <i className="fas fa-wrench text-orange-500 mr-2"></i>
                              {feature}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                    <div className="pt-6 mt-6 border-t border-gray-100">
                      <span className="inline-flex items-center justify-center w-full px-4 py-2 bg-blue-100 text-blue-800 rounded-full text-sm font-semibold group-hover:bg-blue-200 transition-colors">
                        {tool.cta}
                        <i className="fas fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform"></i>
                      </span>
                    </div>                  </div>
                </Link>
              </div>
            ))}
          </div>
        </div>
      </div>

    </div>
  );
};

export default ToolsPage;
